import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BackendUrl } from '../../../backendUrl';
import { NgxSpinnerService } from 'ngx-spinner';

import { map } from "rxjs/operators";

@Component({
	selector: 'app-asset',
	templateUrl: './asset.component.html',
	styleUrls: ['./asset.component.css']
})
export class AssetComponent implements OnInit {
	addHis: any = {}
	assHis = []; freezedetails: any = {}; addressBal: any = {}; usersToken: any = {}; addempty = true; addHiscount = 0; token = localStorage.getItem('Sastana_Token'); userAcc: any; signLoader = false; modalRef: BsModalRef; userAddress = localStorage.getItem('Address'); userAddressSub; privateKey; userBal = 0;
	@ViewChild('create_acc') create_acc: TemplateRef<any>;
	@ViewChild('receive') receive: TemplateRef<any>;
	@ViewChild('sendForm') sendForm: TemplateRef<any>;
	@ViewChild('sendABCForm') sendABCForm: TemplateRef<any>;

	@ViewChild('freezeForm') freezeForm: TemplateRef<any>;
	@ViewChild('Power') Power: TemplateRef<any>;
	@ViewChild('unfreezeForm') unfreezeForm: TemplateRef<any>;
	@ViewChild('unFreezePower') unFreezePower: TemplateRef<any>;
	@ViewChild('swapFirst') swapFirst: TemplateRef<any>;
	@ViewChild('swapForm') swapForm: TemplateRef<any>;
	dep: number = 1;
	tokenTransfer: number = 1
	alltransfer: number = 1
	//  socket;
	backUrl = BackendUrl;
	walletAddress = 'LVVYYqQJSDHM6kudaqc8BrNXNDqnEsiK5D';
	erc20 = '0x994505a7741818bdee134ffa7799c72ff104a7ec';
	getDecimals: any; inum = '0';
	tokenBalance: any = {
		balance: ''
	};
	coinBalance: any;
	balance: any;
	qrimage: any = {}
	freezeAmount: any = {};
	withdrawReward: any;
	expiry: string;
	lastWithdrawTime: any;
	nextWithdrawTime: any;
	timenow: string;
	freezeList: any;
	withdrawList: any;
	abcBalance: any;
	transactionList: any;
	transferList: any;
	accountInfo: any;
	alltransferList: any;
	freezePeriod: any;
	timeString: string;

	constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private modalService: BsModalService, private spinner: NgxSpinnerService) {
		this.conn.coinBalance.subscribe((res: any) => {
						if (res > 0) {
				this.balance = res
			}
		})
		this.conn.tokenBalance.subscribe((res: any) => {
			this.tokenBalance.balance = res
		})
	}

	ngOnInit() {
		this.getQr();
		this.getFromTransactions();
		this.getFreeze();
		this.getReward();
		this.getFreezeUnfreeze();
		this.getWithdraw()
		this.getAbcBalance()
		this.transferHistory();
		this.Energy_bandwidth();
		this.allTransactions()
	}


	Energy_bandwidth() {
		this.conn.postUrl('user_contract/account_Energy_bandwidth', { address: this.userAddress }).subscribe((res: any) => {
			this.accountInfo = res.data;
		})
	}

	transferHistory() {
		this.conn.postUrl('users/contractTransaction', { address: this.userAddress }).subscribe((res: any) => {
			this.transferList = res.data
		})
	}

	allTransactions() {
		this.conn.postUrl('users/allcontractTransactions', {}).subscribe((res: any) => {
			this.alltransferList = res.data
		})

	}


	getFromTransactions() {
		// this.spinner.show()
		this.conn.postUrl('users/txnGetByAddress', { fromAddress: this.userAddress, toAddress: this.userAddress }).subscribe((response: any) => {
			if (response) {
				// this.spinner.hide()
				this.addHis = response.data
			}
		})
	}

	getQr() {
		this.conn.postUrl('users/getAddressDetails', { address: this.userAddress }).subscribe((result: any) => {
			if (result.status == true) {
				this.qrimage.image = result.data.qrimage;
				this.nextWithdrawTime = result.data.next_withdrawal_time
			}
		})
	}

	getToken() {
		this.conn.getRequest('assets/usersToken', this.token).subscribe((res: any) => {
			this.usersToken = res.usersToken;
			for (var k = 0; k < this.usersToken.length; k++) {
				this.usersToken[k].address = this.usersToken[k].address.substring(0, 7) + ". . . ." + this.usersToken[k].address.substring(28, 40);
			}
		});
	}

	getSite() {
		this.conn.getUrl('assets/siteSett').subscribe((resData: any) => {
			this.walletAddress = resData.res.wallet_address;
			this.erc20 = resData.res.erc20;
		});
	}


	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template);
	}
	reciveModal() {
		this.modalRef = this.modalService.show(this.receive);
	}

	freezeModal() {
		this.modalRef = this.modalService.show(this.freezeForm ,  {backdrop: 'static'});
	}

	freezepowerModal() {
		this.modalRef = this.modalService.show(this.Power);
	}

	unfreezepowerModal() {
		var expiryTime = new Date().getTime();
		this.timenow = expiryTime.toString()
		if (this.withdrawReward > 0) {
			if (this.timenow > this.nextWithdrawTime) {
				this.modalRef = this.modalService.show(this.unFreezePower, {backdrop : 'static'});
			}
			else if (this.nextWithdrawTime == '' || this.nextWithdrawTime == undefined) {
				this.modalRef = this.modalService.show(this.unFreezePower, {backdrop : 'static'});
			}
			else {
				this.alert.error('Withdraw after 24 hrs');
			}
		}
		else {
			this.alert.error('No reward amount to withdraw');
		}
	}

	unfreezeModal() {
		this.modalRef = this.modalService.show(this.unfreezeForm ,  {backdrop: 'static'});
	}

	sendModal() {
		if (this.balance > 0) {
			this.modalRef = this.modalService.show(this.sendForm, {backdrop: 'static'});
		}
		else {
			this.alert.error('Insufficient Balance');
		}
	}

	sendABCModal() {
		if (this.abcBalance > 0) {
			this.modalRef = this.modalService.show(this.sendABCForm,{backdrop: 'static'});
		}
		else {
			this.alert.error('Insufficient Token Balance');
		}
	}

	swapFirstModal(swapAddress) {
		this.modalRef = this.modalService.show(this.swapFirst);
	}
	swapModal() {
		this.modalRef.hide();
		this.modalRef = this.modalService.show(this.swapForm);
	}


	freezeKeyup(val, freeze: NgForm) {
		if (val > this.freezedetails.tokenBal) {
			this.alert.error('Insufficient Balance');
			freeze.resetForm();
		}
	}

	unfreezeKeyup(val, freeze: NgForm) {
		if (val > this.freezedetails.Freeze_Details) {
			this.alert.error('Insufficient Balance');
			freeze.resetForm();
		}
	}

	sendFunc(send: NgForm) {
		var data = send.value;
		let obj = {
			fromAddress: this.userAddress,
			toAddress: data.toaddress,
			amount: data.amount
		}
		// this.signLoader = true;
		this.spinner.show()
		if (this.userAddress != data.toaddress) {
			if (data.toaddress.length == 34) {
				if (data.amount != 0) {
					if (data.amount <= this.balance) {
						this.conn.postRequest('users/tokenTransfer', obj, this.token).subscribe((res: any) => {
							if (res.success == true) {
								this.modalRef.hide();
								this.spinner.hide()

								this.alert.success('Transaction Successful');
								window.location.reload()
							} else {
								this.alert.error('Transaction failed');
								// this.signLoader = false;
								this.spinner.hide()

							}
							send.resetForm();
							this.spinner.hide()

							// this.signLoader = false;
						})
					}
					else {
						this.alert.error('Insufficient Balance');
						// this.signLoader = false;
						this.spinner.hide()

					}
				}
				else {
					this.alert.error('Transfer Amount cannot be 0');
					// this.signLoader = false;
					this.spinner.hide()

				}
			}
			else {
				this.alert.error('Invalid To Address');
				// this.signLoader = false;
				this.spinner.hide()

			}

		}
		else {
			this.alert.error('Sender and receiver address cannot be same');
			// this.signLoader = false;
			this.spinner.hide()

		}
	}

	sendAbc(sendabc: NgForm) {
		var data = sendabc.value;
		let obj = {
			fromAddress: this.userAddress,
			toAddress: data.toaddress,
			amount: data.amount
		}
		this.signLoader = true;
		if (this.userAddress != data.toaddress) {
			if (data.amount != 0) {
				this.conn.postRequest('wallet/abcTransferasset', obj, this.token).subscribe((res: any) => {
					if (res.success == true) {
						this.modalRef.hide();
						this.alert.success('Transaction Successful');
						window.location.reload()
					} else {
						this.alert.error(res.msg);
						this.signLoader = false;
					}
					sendabc.resetForm();
					this.signLoader = false;
				})
			}
			else {
				this.alert.error('Transfer Amount cannot be 0');
				this.signLoader = false;
			}
		}
		else {
			this.alert.error('Sender and receiver address cannot be same');
			this.signLoader = false;
		}

	}

	getAbcBalance() {
		this.conn.postUrl('wallet/getABCBalance', { address: this.userAddress }).subscribe((res: any) => {
			this.abcBalance = res.data
		})
	}

	freezeFunc(freeze: NgForm) {
		var data = freeze.value;
		data.fromaddress = this.userAddress
		this.signLoader = true;
		if (data.amount != 0) {
			if (data.amount < this.balance) {
				this.conn.postUrl('vote/freeze', data).subscribe((res: any) => {
					if (res.success == true) {
						this.modalRef.hide();
						this.alert.success(res.msg);
						window.location.reload()
					} else {
						this.alert.error(res.msg);
						this.signLoader = false;
						this.modalRef.hide();

					}
					freeze.resetForm();
					this.signLoader = false;
				})
			}
			else {
				this.alert.error('Insufficient SAST Balance');
				this.signLoader = false;
			}
		}
		else {
			this.alert.error('Freeze Amount cannot be 0');
			this.signLoader = false;
		}
	}

	freezePower(freezepower: NgForm) {
		var data = freezepower.value;
		this.signLoader = true;
		this.conn.postRequest('assets/freezePower', data, this.token).subscribe((res: any) => {
			if (res.status == 1) {
				this.modalRef.hide();
				this.alert.success(res.msg);
			} else {
				this.alert.error(res.msg);
				this.signLoader = false;
			}
			freezepower.resetForm();
			this.signLoader = false;
		})
	}

	unfreezepowers(unfreezepower: NgForm) {
		var data = unfreezepower.value;
		this.signLoader = true;
		let obj = {
			fromAddress: data.address,
			withdraw_amount: this.withdrawReward
		}
		if (data.address == this.userAddress) {
			this.conn.postUrl('contract/withdrawReward', obj).subscribe((res: any) => {
				if (res.success == true) {
					this.modalRef.hide();
					this.alert.success(res.msg);
					window.location.reload()
				} else {
					this.alert.error(res.msg);
					this.signLoader = false;
				}
				unfreezepower.resetForm();
				this.signLoader = false;
			})
		}
		else {
			this.alert.error('Withdraw with your account address');
			this.signLoader = false;
		}
	}

	unfreezeFunc(unfreeze: NgForm) {
		var data = unfreeze.value;
		data.toAddress = this.userAddress
		this.signLoader = true;
		if (data.amount != 0) {
			this.conn.postUrl('vote/unFreeze', data).subscribe((res: any) => {
				if (res.success == true) {
					this.modalRef.hide();
					this.alert.success(res.msg);
					window.location.reload()
				} else {
					this.alert.error(res.msg);
					this.signLoader = false;
					this.modalRef.hide();

				}
				unfreeze.resetForm();
				this.signLoader = false;
			})
		}
		else {
			this.alert.error('UnFreeze Amount cannot be 0');
			this.signLoader = false;
		}
	}

	swapFunc(swap: NgForm) {
		var data = swap.value;
		this.signLoader = true;
		this.conn.postRequest('assets/swap', data, this.token).subscribe((res: any) => {
			if (res.status == 1) {
				this.modalRef.hide();
				this.alert.success(res.msg);
			} else {
				this.alert.error(res.msg);
			}
			swap.resetForm();
			this.signLoader = false;
		})
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.alert.success('Copied to the clipboard');
	}

	getFreeze() {
		this.conn.postUrl('vote/getFreezeAmount', { address: this.userAddress }).subscribe((res: any) => {
			if (res.success == true) {
				this.freezeAmount = res.data.freezeamount
				this.freezePeriod = res.data.unfreezeTime
			}
			else {
				this.freezeAmount = 0
			}
		})
	}

	getReward() {
		this.conn.postUrl('contract/getReward', { address: this.userAddress }).subscribe((res: any) => {
			if (res.status == true) {
				this.withdrawReward = res.data
			}
		})
	}

	getWithdraw() {
		this.conn.getUrl('contract/withdraw_list').subscribe((res: any) => {
			if (res.status == true) {
				this.withdrawList = res.data
			}
		})
	}

	getFreezeUnfreeze() {
		this.conn.postUrl('vote/freezeList', {}).subscribe((res: any) => {
			if (res.success == true) {
				this.freezeList = res.data
			}
		})
	}

	preventNonNumericalDotInput(evt: any) {
		if ((evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) && evt.which != 46) {
			evt.preventDefault();
		}
	}
}
